import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    favoriteResourcesExpandedOn: false,
    followedResourcesExpandedOn: false,
    notificationsExpandedOn: false,
    savedSearchesExpandedOn: false,
    myResourcesListExpandedOn: false
};

const myFevirExpandedSlice = createAppSlice({
    name: "myFevirExpanded",
    initialState,
    reducers: create => ({
        favoriteResourcesExpanded: create.reducer((state) => { state.favoriteResourcesExpandedOn = true; }),
        favoriteResourcesCollapsed: create.reducer((state) => { state.favoriteResourcesExpandedOn = false; }),
        followedResourcesExpanded: create.reducer((state) => { state.followedResourcesExpandedOn = true; }),
        followedResourcesCollapsed: create.reducer((state) => { state.followedResourcesExpandedOn = false; }),
        notificationsExpanded: create.reducer((state) => { state.notificationsExpandedOn = true; }),
        notificationsCollapsed: create.reducer((state) => { state.notificationsExpandedOn = false; }),
        savedSearchesExpanded: create.reducer((state) => { state.savedSearchesExpandedOn = true; }),
        savedSearchesCollapsed: create.reducer((state) => { state.savedSearchesExpandedOn = false; }),
        myResourcesListExpanded: create.reducer((state) => { state.myResourcesListExpandedOn = true; }),
        myResourcesListCollapsed: create.reducer((state) => { state.myResourcesListExpandedOn = false; }),
    }),
    selectors: {
        selectFavoriteResourcesExpanded: editMode => editMode.favoriteResourcesExpandedOn,
        selectFollowedResourcesExpanded: editMode => editMode.followedResourcesExpandedOn,
        selectNotificationsExpanded: editMode => editMode.notificationsExpandedOn,
        selectSavedSearchesExpanded: editMode => editMode.savedSearchesExpandedOn,
        selectMyResourcesListExpanded: editMode => editMode.myResourcesListExpandedOn,
    },
})

export const { favoriteResourcesExpanded,
    favoriteResourcesCollapsed,
    followedResourcesExpanded,
    followedResourcesCollapsed,
    notificationsExpanded,
    notificationsCollapsed,
    savedSearchesExpanded,
    savedSearchesCollapsed,
    myResourcesListExpanded,
    myResourcesListCollapsed } = myFevirExpandedSlice.actions

export const { selectFavoriteResourcesExpanded, selectFollowedResourcesExpanded, selectNotificationsExpanded,
    selectSavedSearchesExpanded,
    selectMyResourcesListExpanded } = myFevirExpandedSlice.selectors

export default myFevirExpandedSlice